import styled from "styled-components"

export const StyledBody = styled.div`
  margin-bottom: ${({ theme }) => theme.space[5]};
`
